import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=b63ae930&scoped=true&"
var script = {}
import style0 from "./Error404.vue?vue&type=style&index=0&id=b63ae930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63ae930",
  null
  
)

export default component.exports